import { Attributes, DateUtils, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import LadderAge from './LadderAge';

@NeoModel
export default class LadderLimit extends ModelBase {
    static typeName = "LadderLimit";

    public ladderLimitId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public ladderAgeId: number | null = null;

    @Attributes.Parent(() => LadderAge)
    public ladderAge: LadderAge | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date | null = new Date(DateUtils.today());

    @Attributes.Integer()
    public limit: number = 0;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New ladder limit";
        } else {
            return "Ladder Limit";
        }
    }
}